import { Divider as BaseDivider, DividerProps } from 'components/common'

export type { DividerProps }

export const Divider = ({ style = {}, ...rest }: DividerProps): JSX.Element => (
  <>
    <BaseDivider
      style={{
        ...style,

        marginLeft: '-24px',
        marginRight: '-24px',
        width: 'auto',
      }}
      {...rest}
    />
  </>
)
